// Turbo preserves window scroll on refresh; index tables scroll independently.
document.addEventListener("turbo:before-render", event => {
  if (event.detail.renderMethod !== "morph") return

  const render = event.detail.render
  event.detail.render = async (...args) => {
    const positions = Array.from(document.querySelectorAll("[data-index-scroll]"), element => ({
      id: element.id,
      top: element.scrollTop,
      left: element.scrollLeft
    }))

    await render(...args)

    for (const { id, top, left } of positions) {
      const element = document.getElementById(id)
      if (element?.hasAttribute("data-index-scroll")) {
        element.scrollTop = top
        element.scrollLeft = left
      }
    }
  }
})
